document.addEventListener("DOMContentLoaded", () => {
  const ingredientsItems = document.querySelectorAll(".ingredients-cards__item");
  const ingredientsCarousel = document.querySelector(".ingredients-carousel");
  const closeButtons = document.querySelectorAll(".ingredients-carousel__close");
  const emblaComponent = document.querySelector(".ingredients-carousel__carousel embla-component");

  ingredientsItems.forEach(item => {
    item.addEventListener("click", () => {
      const itemName = item.querySelector(".ingredients-cards__item__name")?.textContent.trim();
      if (!itemName) return;

      ingredientsCarousel.classList.add("active");

      const slides = document.querySelectorAll(".embla__slide.ingredients-carousel__item");
      let targetIndex = 0;

      slides.forEach((slide, index) => {
        const slideName = slide.querySelector(".ingredients-carousel__name")?.textContent.trim();
        if (slideName === itemName) {
          targetIndex = index;
        }
      });

      if (emblaComponent) {
        console.log(emblaComponent); // Check the DOM element
        // Wait for emblaApi to be available
        const waitForEmbla = setInterval(() => {
          if (emblaComponent.emblaApi) {
            clearInterval(waitForEmbla);
            console.log('emblaComponent.emblaApi', emblaComponent.emblaApi)
            console.log("Target Index:", targetIndex);
            emblaComponent.emblaApi.scrollTo(6);

            setTimeout(() => {
              if (emblaComponent.emblaApi) {
            console.log("Target Index:", targetIndex);
                emblaComponent.emblaApi.scrollTo(targetIndex, true);
              } else {
                console.warn("emblaApi not ready yet");
              }
            }, 200);
          }
        }, 50);
      }
    });
  });

  closeButtons.forEach(button => {
    button.addEventListener("click", () => {
      ingredientsCarousel.classList.remove("active");
    });
  });
});